export const SET_IS_NEW_DESIGN = "SET_IS_NEW_DESIGN";
export const SET_CURRENT_TEMPLATE = "SET_CURRENT_TEMPLATE";

export function setIsNewDesign(isNewDeisgn) {
  return {
    type: SET_IS_NEW_DESIGN,
    payload: isNewDeisgn,
  };
}

export function setCurrentTemplate(currentTemplate) {
  return {
    type: SET_CURRENT_TEMPLATE,
    payload: currentTemplate,
  };
}



// WEBPACK FOOTER //
// ./src/reducers/settings/settingsActions.js